import { Reference, ReferenceInput } from 'sr-types/lib/note/v1/graphql';
import { useMutationWithContext } from '../../common/hooks/useMutationWithContext';
import { failedToastMessage, successToastMessage } from '../../common/utils/commonUtils';
import { associateStatusNote, client } from '../helpers/production';

type StatusNoteInputType = {
    productionId: string;
    note: ReferenceInput;
    showToastMessage?: boolean;
};

type AssociateStatusNoteResponse = {
    data: {
        associateCurrentStatusNote: {
            id: string;
            reference: Reference;
            errors?: Array<{ message: string; code: string }>;
        };
    };
};

export const useAssociateStatusNoteToProduction = (showToastMessage: boolean = true) => {
    const [associateNote, { loading: statusNoteSaving }] = useMutationWithContext(associateStatusNote, client);

    const associateProductionStatusNote = ({
        productionId,
        note,
        showToastMessage: callShowToastMessage
    }: StatusNoteInputType): Promise<Reference> => {
        const effectiveShowToast = typeof callShowToastMessage === 'boolean' ? callShowToastMessage : showToastMessage;

        return associateNote({
            variables: {
                productionId,
                note
            }
        })
            .then((associateStatusNoteResponse: AssociateStatusNoteResponse) => {
                if (associateStatusNoteResponse.data.associateCurrentStatusNote.errors) {
                    effectiveShowToast && failedToastMessage('note.status.save.failure');
                    return Promise.reject(associateStatusNoteResponse.data.associateCurrentStatusNote.errors);
                } else {
                    effectiveShowToast && successToastMessage('note.status.save.success');
                    return Promise.resolve(associateStatusNoteResponse.data.associateCurrentStatusNote.reference);
                }
            })
            .catch((err) => {
                effectiveShowToast && failedToastMessage('note.status.save.failure');
                return Promise.reject(err);
            });
    };

    return { associateProductionStatusNote, statusNoteSaving };
};
